<template>
  <div id="userLayout">
    <a-layout style="height: 100vh">
      <a-layout-header class="header">
        <a-space>
          <img
            alt=""
            class="logo"
            src="https://www.yadiratogether.top//usr/themes/Xc/assets/img/link.png"
          />
          <div class="title">鱼答答 AI答题应用平台</div>
        </a-space>
      </a-layout-header>
      <a-layout-content class="content">
        <router-view></router-view>
      </a-layout-content>
      <a-layout-footer class="footer"
        ><a href="https://www.baidu.com"> 编程导航 </a></a-layout-footer
      >
    </a-layout>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
#userLayout {
  text-align: center;
  background: linear-gradient(to right, #fefefe, #fff);
}

#userLayout .logo {
  height: 48px;
  width: 48px;
}

#userLayout .header {
  margin-top: 16px;
  font-size: 21px;
}

#userLayout .content {
  margin-bottom: 16px;
}

.footer {
  background: #fefefe;
  padding: 16px;
  text-align: center;
}
</style>
